import { useRef, useState } from "react";

const extOf = (name) => (name.split(".").pop() || "").toLowerCase();

export function splitFiles(files, exts, label) {
  const ok = [];
  const bad = [];
  Array.from(files).forEach((f) => (exts.includes(extOf(f.name)) ? ok : bad).push(f));
  const error = bad.length
    ? `${bad.map((f) => f.name).join(", ")} ${bad.length === 1 ? "is" : "are"} not supported. ${label}`
    : null;
  return { ok, error };
}

export const fmtSize = (b) => (b >= 1024 ** 3 ? `${(b / 1024 ** 3).toFixed(2)} GB` : `${(b / 1024 ** 2).toFixed(1)} MB`);

export function DropZone({ testId, accept, onFiles, disabled, icon: Icon, label, dropLabel, hint }) {
  const [over, setOver] = useState(false);
  const depth = useRef(0);
  const input = useRef(null);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  const handlers = {
    onDragEnter: (e) => { stop(e); depth.current += 1; setOver(true); },
    onDragOver: (e) => { stop(e); e.dataTransfer.dropEffect = disabled ? "none" : "copy"; },
    onDragLeave: (e) => { stop(e); depth.current -= 1; if (depth.current <= 0) { depth.current = 0; setOver(false); } },
    onDrop: (e) => { stop(e); depth.current = 0; setOver(false); onFiles(e.dataTransfer.files); },
  };
  const tone = over && !disabled ? "border-amber-700 bg-amber-100 ring-4 ring-amber-200" : disabled ? "border-stone-300 bg-stone-50 text-stone-400" : "border-amber-800/40 bg-amber-50/50 hover:bg-amber-50";
  return (
    <div data-testid={`${testId}-zone`} data-dragover={over ? "true" : "false"} {...handlers}
      className={`rounded-xl border-2 border-dashed transition-colors ${tone}`}>
      <input ref={input} data-testid={`${testId}-input`} type="file" accept={accept} multiple className="hidden" disabled={disabled}
        onChange={(e) => { onFiles(e.target.files); e.target.value = ""; }} />
      <button type="button" data-testid={`${testId}-button`} disabled={disabled} onClick={() => input.current?.click()}
        className={`w-full min-h-[96px] px-4 py-4 flex flex-col items-center justify-center gap-1 rounded-xl font-semibold ${disabled ? "cursor-not-allowed" : "text-amber-900"}`}>
        <span className="flex items-center gap-2 text-base"><Icon className="h-5 w-5" /> {over && !disabled ? dropLabel : label}</span>
        <span className="hidden md:block text-xs font-normal text-stone-500">{hint || "Drag & Drop Files Here or Click to Browse"}</span>
        {!disabled && <span className="md:hidden text-xs font-normal text-stone-500">Tap to choose from your library or camera</span>}
      </button>
    </div>
  );
}
